import React from "react";

import { PRODUCT_CATEGORY_NAMES } from "@/constants/products";
import { ProductCategory } from "@/custom-types/BrandDetail";

import CoinList from "@/components/CoinList";

const getCategoryValues = (name: string) => {
  const categoryIcon: Record<string, string> = {
    "Books & Games": "booksandgames",
    "Delta-8 THC": "delta8",
    "Hemp CBD": "hempcbd",
  };

  const categoryLabel: Record<string, string> = {
    "Books & Games": "Books/Games",
  };

  const categoryValue: Record<string, string> = {
    "Books & Games": "books-games",
    "Delta-8 THC": "delta-8-thc",
    "Hemp CBD": "hemp-cbd",
  };

  return {
    icon: (
      PRODUCT_CATEGORY_NAMES[name]?.icon ||
      categoryIcon[name] ||
      name
    ).toLowerCase(),
    label: categoryLabel[name] || name,
    value: categoryValue[name] || name,
  };
};

const BrandProductCoins = ({
  sortedCategories,
  brandSlug,
  brandId,
  featureTier,
}: {
  sortedCategories: ProductCategory[];
  brandSlug: string;
  brandId: number;
  featureTier?: string;
}) => {
  const categoryData = sortedCategories.map((category) => {
    const { icon, label, value } = getCategoryValues(category.name);
    return {
      icon: `coinList/${icon}.svg`,
      label,
      value,
    };
  });

  if (!sortedCategories || categoryData.length === 0) {
    return null;
  }

  return (
    <div>
      <CoinList
        title="Shop by category"
        coinData={categoryData}
        className="-mx-lg p-sm pb-md"
        hrefLink={`/brands/${brandSlug}/catalog`}
        queryParamAsPath
        clickEventCategory={`brand ${featureTier?.toLowerCase()}`}
        clickEventProps={{
          brandId,
        }}
      />
    </div>
  );
};

export default BrandProductCoins;
